import React from 'react';
import classnames from 'classnames/bind';
import { OptimizedImg } from '@commonPackage/components';
import { ModuleTitle } from '../../styles';
import styles from './index.module.less';

const cx = classnames.bind(styles);

const Box = ({ content, icon, style }: { content: string; icon: string; style: React.CSSProperties }) => (
  <div className={cx('box')} style={style}>
    <OptimizedImg src={icon} width={62} loading="lazy" />
    <div>{content}</div>
  </div>
);

export const Process = () => {
  const getStyle = (t: number, l: number, w: number, h: number) => ({
    top: `${t}px`,
    left: `${l}px`,
    width: `${w}px`,
    height: `${h}px`,
  });
  const PROCESS_LIST = [
    {
      content: '提交需求联系瑶台',
      style: getStyle(0, 0, 268, 144),
      icon: 'https://static.fuxi.netease.com/yaotai/portal/20220908/l7so6bla_581037.png',
    },
    {
      content: '对接客户经理',
      style: getStyle(0, 328, 268, 144),
      icon: 'https://static.fuxi.netease.com/yaotai/portal/20220908/l7so5j9m_544329.png',
    },
    {
      content: '根据场景匹配产品',
      style: getStyle(0, 656, 268, 144),
      icon: 'https://static.fuxi.netease.com/yaotai/portal/20220908/l7so5j9l_544329.png',
    },
    {
      content: '协议&付款',
      style: getStyle(0, 984, 216, 144),
      icon: 'https://static.fuxi.netease.com/yaotai/portal/20220908/l7so5j9j_544327.png',
    },
    {
      content: '正式使用',
      style: getStyle(204, 0, 268, 144),
      icon: 'https://static.fuxi.netease.com/yaotai/portal/20220908/l7so5j9i_544326.png',
    },
    {
      content: '项目彩排',
      style: getStyle(204, 328, 268, 144),
      icon: 'https://static.fuxi.netease.com/yaotai/portal/20220908/l7so5j9d_544321.png',
    },
    {
      content: '开通账号、服务经理、支持与培训',
      style: getStyle(204, 656, 544, 144),
      icon: 'https://static.fuxi.netease.com/yaotai/portal/20220908/l7so5j9c_544320.png',
    },
  ];
  return (
    <div className={cx('process-container')}>
      <ModuleTitle marginBottom={72} marginTop={106}>
        购买使用
        <span className={cx('highlight')}>流程</span>
      </ModuleTitle>
      <div className={cx('process-content')}>
        {PROCESS_LIST.map(item => {
          return <Box key={item.icon} {...item} />;
        })}
      </div>
    </div>
  );
};
